import React from 'react'
import CallUs from '../components/Callus'
import { Navbar } from '../components/navbar'
import { SectionTitle } from '../components/sectionTitile'
import Header from '../header'
import styled from 'styled-components'
import themes from '../themes'
import Navigation from '../navigation'
import { NavLink } from 'react-router-dom'
import Logo1 from '../Logos/abdul.png'
import Logo2 from '../Logos/malcom.png'
import Logo3 from '../Logos/usmaaaa.png'
import LogoBackground from '../Logos/backgronds/logoBackground.jpg'
import LogoBackground1 from '../Logos/backgronds/graphicsBackground.jpg'
import Back from '../Logos/backgronds/newgra.png'
import { BackToTop } from '../components/backToTop'
import { Footer } from '../components/footer'


const HeaderStyle = styled(Header)`
color:${themes.primary};
justify-content:left;
`;

const Background = styled.div`
width:100%;
height:100vh;
background-image:url(${Back});
margin:none;

`;

// const BackgroundFilter = styled.div`
// width:100%;
// height:100vh;
// background-color:rgba(55,55,55,0.99);
// background-size:cover;
// background-repeat:no-repeat;
// opacity:0.8;
// padding:2rem;

// `;



const LogoImageContainer = styled.img`
width:20%;

@media screen and (max-width:580px){
  /*   align-items:center;
    text-justify:center; */
};
`
const Container = styled.div`
display:flex;
justify-content:space-around;
padding:2rem;
align-items:center;

@media screen and (max-width:780px){
    display:flex;
    flex-direction:column;
}

`
const Illustration = styled.img`
width:100%;
margin-right:2rem;
`

const ContentsContainer = styled.div`
display:flex;
flex-direction:column;
`;

const LogoContainer = styled.div`
`

const LogoRow = styled.div`
display:flex;
justify-content:space-between;
padding:2rem;
width:100%;
`;


const Paragraph = styled.p`
line-height:2.7;
padding:2rem;
color:${themes.primary};
width:50%;


@media screen and (max-width:780px){
    width:100%;

}`

const LogoCol = styled.div`
`

function Graphics(){
    return(
        <div>
              <Navbar />
                <CallUs />
                <ContentsContainer>
                    <Background>
                        {/* <BackgroundFilter> */}
                        <HeaderStyle>Graphics Design Company</HeaderStyle>
                <h6 style={{textAlign:"center",color:"#000080",color:"#000080"}}>Creating the graphics that your customers want</h6>
                <Paragraph>One of the most important thing that takes your business to the next level
                    is an attractive graphics design, it gives some more information about your business and also helps your 
                    customers to get some information about your business. At Tecspot, we help you design the graphics 
                    that wins the heart of your customers and the one they will remember all the time.
                </Paragraph>
                <Navigation><NavLink to='/contacts'>Contact us</NavLink> </Navigation>
                        {/* </BackgroundFilter> */}
                    </Background>
               
                </ContentsContainer>

                <ContentsContainer>
                <HeaderStyle>Logo Design</HeaderStyle>
                <h6 style={{padding:".5rem",textAlign:"center"}}>Spectacular Logo Design</h6>
               <Container>
                <Illustration src={LogoBackground}/>
                <p style={{lineHeight:"2.0"}}>As professionals, we understand that logo is an identity that help your business stay in the mind of your customers.
                    Its part of the branding the keeps you in the heart of your customers.
                    We help you create a unique and spectacular logo design that carrys the services you render and makes you stand out.
                </p>
                </Container>
                <Navigation><NavLink to='/web-design'>Check our websites</NavLink> </Navigation>
                </ContentsContainer>

                <LogoContainer>
                    <LogoRow>
                        <LogoImageContainer src={Logo1}/>
                        <LogoImageContainer src={Logo2}/>
                        <LogoImageContainer src={Logo3}/>

                        </LogoRow>
                        <LogoRow>
                        <LogoImageContainer src={Logo1}/>
                        <LogoImageContainer src={Logo2}/>
                        <LogoImageContainer src={Logo3}/>

                        </LogoRow>
                    
                </LogoContainer>
                <Footer/>
                <BackToTop/>
        </div>
    )
}

export default Graphics